import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';
import { IconButton, ListItem, ListItemIcon, ListItemText, Stack } from '@mui/material';

import { SpanWithEllipsisAndTooltipOnOverflow } from 'common';

import { useReactFlowViewContext } from '../../../../context/context';

interface Props {
  fileReference: string;
  onRemove: (fileReference: string) => void;
}

export function FileReferenceSelected(props: Props) {
  const { fileReference, onRemove } = props;
  const { isEditable } = useReactFlowViewContext();
  return (
    <ListItem
      secondaryAction={
        <IconButton
          onClick={() => onRemove(fileReference)}
          edge="end"
          aria-label="Delete file"
          size="small"
          disabled={!isEditable}
        >
          <DeleteOutlineIcon />
        </IconButton>
      }
    >
      <ListItemText>
        <Stack direction="row">
          <ListItemIcon>
            <PlagiarismOutlinedIcon />
          </ListItemIcon>
          <SpanWithEllipsisAndTooltipOnOverflow placement="left">
            {fileReference}
          </SpanWithEllipsisAndTooltipOnOverflow>
        </Stack>
      </ListItemText>
    </ListItem>
  );
}
